import { render, staticRenderFns } from "./ViewPayGrade.vue?vue&type=template&id=924dc844"
import script from "./ViewPayGrade.vue?vue&type=script&lang=js"
export * from "./ViewPayGrade.vue?vue&type=script&lang=js"
import style0 from "./ViewPayGrade.vue?vue&type=style&index=0&id=924dc844&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports